import { render, staticRenderFns } from "./PersonalPropertyInfo.vue?vue&type=template&id=4655207b"
import script from "./PersonalPropertyInfo.vue?vue&type=script&lang=ts"
export * from "./PersonalPropertyInfo.vue?vue&type=script&lang=ts"
import style0 from "./PersonalPropertyInfo.vue?vue&type=style&index=0&id=4655207b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports